/** BCP-47 language tag (e.g. "en", "fr", "ar"). */
export type LanguageCode = string;

/** Payload sent to the translation API. */
export interface TranslationInput {
    /** BCP-47 source language tag. Omit to let the service auto-detect. */
    sourceLanguage?: LanguageCode;

    /** One or more BCP-47 target language tags. */
    targetLanguages: LanguageCode[];

    /** The content to translate. */
    text: string;

    /** Content format: `"text"` for plain text, `"html"` for rich/HTML content. */
    format: 'text' | 'html';
}

/** A single translated result returned by the API. */
export interface TranslationResult {
    /** The translated text in the target language. */
    translatedText: string;

    /** Tag the service detected, present when `sourceLanguage` was omitted. */
    detectedSourceLanguage?: LanguageCode;

    /** The target language this result corresponds to. */
    targetLanguage: LanguageCode;

    /** Whether the source and target languages are the same. */
    isSourceTargetLanguageSame?: boolean;
}

/** Top-level response from the translation API. */
export interface TranslationData {
    translations: TranslationResult[];
}
export class TranslationValidationError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'TranslationValidationError';
    }
}
